export const libConf = {
  drugStatusCode: {
    listed: '1068401312472760803', //批准上市
    applyList: '1068401241203147002', //申请上市
    clinicalThird: '1068401241119261043', //临床三期
    clinicalSecond: '1068401241119261041', //临床二期
    clinicalFirst: '1068401240934712080', //临床一期
    applyClinical: '1068401298358927737', //临床申请
  },
  drugStatus: ['1068401312472760803','1068401241203147002','1068401241119261043','1068401241119261041','1068401240934712080','1068401298358927737'],
  drugStatusNames: ['批准上市', '申请上市', '临床三期', '临床二期', '临床一期', '临床申请'],
  drugType: ['company', 'therapyArea', 'indication', 'targets', 'moa'], //首页图表类型 company公司 therapyArea治疗领域 indication适应症 targets靶点 moa作用机制
  drugDesc: { //首页图表描述
    company: {
      title: '公司研发管线Top20',
      tip: '在中国大陆范围内，最高研发状态处于批准上市、申请上市、临床三期、临床二期、临床一期、临床申请等公司的药物数量，依据状态的总量排名展示Top20。',
      tipGlobal: '在全球范围内，最高研发状态处于批准上市、申请上市、临床三期、临床二期、临床一期、临床申请等公司的药物数量，依据状态的总量排名展示Top20。',
      tableName: '公司'
    },
    therapyArea: {
      title: '治疗领域',
      tip: '在中国大陆范围内，最高研发状态处于批准上市、申请上市、临床三期、临床二期、临床一期、临床申请等治疗领域的药物数量。',
      tipGlobal: '在全球范围内，最高研发状态处于批准上市、申请上市、临床三期、临床二期、临床一期、临床申请等治疗领域的药物数量。',
      tableName: '治疗领域'
    },
    indication: {
      title: '适应症Top20',
      tip: '在中国大陆范围内，最高研发状态处于批准上市、申请上市、临床三期、临床二期、临床一期、临床申请等适应症的药物数量，依据状态的总量排名展示Top20。',
      tipGlobal: '在全球范围内，最高研发状态处于批准上市、申请上市、临床三期、临床二期、临床一期、临床申请等适应症的药物数量，依据状态的总量排名展示Top20。',
      tableName: '适应症'
    },
    targets: {
      title: '靶点Top20',
      tip: '在中国大陆范围内，最高研发状态处于批准上市、申请上市、临床三期、临床二期、临床一期、临床申请等靶点的药物数量，依据状态的总量排名展示Top20。',
      tipGlobal: '在全球范围内，最高研发状态处于批准上市、申请上市、临床三期、临床二期、临床一期、临床申请等靶点的药物数量，依据状态的总量排名展示Top20。',
      tableName: '靶点'
    },
    moa: {
      title: '作用机制Top20',
      tip: '在中国大陆范围内，最高研发状态处于批准上市、申请上市、临床三期、临床二期、临床一期、临床申请等作用机制的药物数量，依据状态的总量排名展示Top20。',
      tipGlobal: '在全球范围内，最高研发状态处于批准上市、申请上市、临床三期、临床二期、临床一期、临床申请等作用机制的药物数量，依据状态的总量排名展示Top20。',
      tableName: '作用机制'
    },
  },
}

//搜索历史
export const historyQueryKey = 'drug-chemical-query-history'
export const historyRdStatusKey = 'drug-chemical-rdstatus-history'

//数据查询 - 类型
export const queryType = {
  TD: '药物名称',
  TT: '靶点',
  TI: '适应症',
  TC: '公司',
  TM: '作用机制'
}

export const basicUrl = 'https://mdata.pharmacodia.com'

//个人中心、登录域名
export const serviceUser = basicUrl + '/personalCenter/#'

//分享接口参数
export const shareParamsUrl = basicUrl + '/chemistry/#/home'

//分享路径
export const shareHomeUrl = basicUrl + '/chemistry'




// WEBPACK FOOTER //
// ./src/common/conf.js